import { getRole, getTenantId } from "../auth/session";
import { User, Shield, Building2, Lock } from "lucide-react";

export function ProfilePage() {
  const role = getRole();
  const tenantId = getTenantId();

  return (
    <div>
      <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">My Profile</h2>

      <div className="max-w-lg space-y-4">
        <div className="rounded-lg border border-gray-200 bg-white dark:border-riot-navy-700 dark:bg-riot-navy-800 p-5">
          <div className="mb-4 flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-riot-gold-100 text-riot-gold-500">
              <User size={24} />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900 dark:text-white">Platform User</p>
              <p className="text-xs text-gray-400 dark:text-riot-navy-400">user@company.com</p>
            </div>
          </div>

          <dl className="space-y-3 text-sm">
            <div className="flex items-center gap-2">
              <Shield size={14} className="text-gray-400 dark:text-riot-navy-400" />
              <dt className="w-20 text-gray-400 dark:text-riot-navy-400">Role</dt>
              <dd className="font-medium capitalize text-gray-700 dark:text-riot-navy-200">{role?.replace(/_/g, " ") ?? "-"}</dd>
            </div>
            <div className="flex items-center gap-2">
              <Building2 size={14} className="text-gray-400 dark:text-riot-navy-400" />
              <dt className="w-20 text-gray-400 dark:text-riot-navy-400">Tenant</dt>
              <dd className="font-mono text-xs text-gray-600 dark:text-riot-navy-200">{tenantId ?? "-"}</dd>
            </div>
          </dl>
        </div>

        <div className="rounded-lg border border-gray-200 bg-white dark:border-riot-navy-700 dark:bg-riot-navy-800 p-5">
          <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-gray-900 dark:text-white">
            <Lock size={14} className="text-gray-400 dark:text-riot-navy-400" /> Change Password
          </h3>
          <div className="space-y-3">
            <input type="password" placeholder="Current password" className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm dark:border-riot-navy-600 dark:bg-riot-navy-800 dark:text-white" />
            <input type="password" placeholder="New password" className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm dark:border-riot-navy-600 dark:bg-riot-navy-800 dark:text-white" />
            <input type="password" placeholder="Confirm new password" className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm dark:border-riot-navy-600 dark:bg-riot-navy-800 dark:text-white" />
            <button className="rounded-md bg-riot-gold-400 px-4 py-2 text-sm font-medium text-riot-navy-900 hover:bg-riot-gold-500 active:bg-riot-gold-600">Update Password</button>
          </div>
        </div>
      </div>
    </div>
  );
}
